import { File } from "./File";
import { Event } from "./Event";
import { Participant } from "./Participant";
import { Document } from "./Document";
import { User } from "./User";
import { Matter } from "./Matter";

export const activityTypes = {
  event_created: {
    label: "Event created",
    color: "blue",
  },
  file_created: {
    label: "File created",
    color: "green",
  },
};

export type ActivityType = keyof typeof activityTypes;

interface AcitivityData {
  fileId?: File["_id"];
  file?: File;
  eventId?: Event["_id"];
  event?: Event;
  participantId?: Participant["_id"];
  participant?: Participant;
  documentId?: Document["_id"];
  document?: Document;
}

export interface Activity {
  _id: string;
  matterId: Matter["_id"];
  matter?: Matter;
  userId: User["_id"];
  user: User;
  type: ActivityType;
  data?: AcitivityData;

  createdAt: Date;
  updatedAt: Date;
}
